<template>
	<button
		v-if="visible"
		type="button"
		:class="component.variants({color, type, size})"
	>
		<component
			:is="icon"
			v-if="icon"
			class="w-5 h-5"
		/>
		<h1 v-if="text">
			{{ text }}
		</h1>
	</button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ComponentName } from "../constants";
import { EbButton } from "./eb-button";

export default defineComponent({
	name: ComponentName.EbButton,
	props: {
		text: {
			type: String
		},
		type: {
			type: String
		},
		color: {
			type: String
		},
		size: {
			type: String
		},
		icon: {
			type: String
		},
		visible: {
			type: Boolean,
			default: true
		}
	},
	setup() {
		const component: EbButton = new EbButton();

		return { component };
	}
});
</script>
